import { Stack, styled, Typography } from '@mui/material';
import { FormLogin, FormLoginType } from 'app/pages/LoginPage/components/FormLogin';
import { useFlash } from 'contexts/flash';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { StorageServices } from 'services/storage';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { LayoutNoAuth } from 'app/components/templates/LayoutNoAuth';
import { StyledParams } from 'types/common';
import { login } from 'services/auth';
import { useSystemInfo } from 'contexts/systemInfo';
const storage = new StorageServices();

export const LoginPage = () => {
  const { systemInfo } = useSystemInfo();
  const { setFlash } = useFlash();
  const navigate = useNavigate();
  const {
    asyncCallback: submitLogin,
    errorReturnApi,
    setErrorReturnApi
  } = useAsyncCallback(
    async (data: FormLoginType) => {
      const dataRes = await login(data);
      setFlash({ type: 'success', message: 'You are successfully logged in' });
      storage.setAccessToken(dataRes.accessToken);
      storage.setRefreshToken(dataRes.refreshToken);
      navigate('/clients');
    },
    [navigate, setFlash]
  );

  const handleSubmitForm = useCallback(
    (data: FormLoginType) => {
      setErrorReturnApi('');
      return submitLogin(data);
    },
    [submitLogin, setErrorReturnApi]
  );

  return (
    <LayoutNoAuth>
      <Wrapper>
        <Stack pt={8.375} pb={3.5} width={'100%'} alignItems={'center'} minHeight={'100vh'}>
          <Stack
            px={{ xs: 3.125, sm: 0 }}
            mt={3}
            width={'100%'}
            maxWidth={{ xs: 'unset', sm: 402 }}>
            <Stack width={'100%'} alignItems={'center'} gap={2.5} mb={6.25}>
              {systemInfo?.logoUrl && <img alt={'logo'} width={96} src={systemInfo?.logoUrl} />}
              <img alt={'logo'} width={306} src={'/images/logo_text_login.png'} />
              <TextTitleStyled>
                Proud To Be A 100% Indigenous Owned And Operated Company
              </TextTitleStyled>
            </Stack>
            <FormLogin errorReturnApi={errorReturnApi} onSubmit={handleSubmitForm} />
          </Stack>
        </Stack>
      </Wrapper>
    </LayoutNoAuth>
  );
};

const Wrapper = styled(Stack)(() => ({
  height: '100vh',
  overflowY: 'scroll'
}));
const TextTitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '16px',
  fontWeight: '700',
  color: theme.colors.base,
  width: 271,
  textAlign: 'center'
}));
